import { GridLarge, GridMedium, GridSmall } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const buttons = [{
  value: GridSmall,
  key: 'small',
}, {
  value: GridMedium,
  key: 'medium',
}, {
  value: GridLarge,
  key: 'large',
}]

export default buttons
